<script setup lang="ts">
import type { ICopilotAction } from "~/utils/interfaces/copilot-interfaces";
import { CopilotWelcomeSuggestions } from "~/utils/options/copilot.options";

withDefaults(
  defineProps<{
    /** The welcome screen's own examples unless a caller puts another set forward. */
    suggestions?: ICopilotAction[];
    disabled?: boolean;
  }>(),
  { suggestions: () => CopilotWelcomeSuggestions },
);

const emit = defineEmits<{
  pick: [action: ICopilotAction];
}>();
</script>

<template>
  <div class="flex flex-col gap-2.5">
    <span class="body_regular text-primary-color">Ou posez une question directement :</span>

    <!--
      Rows rather than the wrapping pills a streamed answer proposes (`CopilotActions`): these are
      whole sentences, and the design stacks them full width so each one reads as one example.
    -->
    <div class="flex flex-col gap-1.5" role="group" aria-label="Exemples de questions">
      <button
        v-for="suggestion of suggestions"
        :key="suggestion.actionId"
        type="button"
        class="meta_regular w-full cursor-pointer rounded-lg border border-stroke-color bg-light-color px-3 py-2 text-left text-secondary-color transition-colors hover:border-primary-blue-color hover:text-primary-blue-color disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="disabled"
        @click="emit('pick', suggestion)"
      >
        {{ suggestion.label }}
      </button>
    </div>
  </div>
</template>
